import { createTheme } from '@mui/material/styles';
import createBaseThemeSettings from './createBaseThemeSettings';

export const defaultThemeSettings = createBaseThemeSettings();
export default createTheme(defaultThemeSettings);
